import React from 'react';

const LinkExternalIcon: React.FC = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.75 7.25L15.75 2.75M15.75 2.75H11.25M15.75 2.75L9.75 8.75M7.5 4.25H5.85C4.58988 4.25 3.95982 4.25 3.47852 4.49524C3.05516 4.71095 2.71095 5.05516 2.49524 5.47852C2.25 5.95982 2.25 6.58988 2.25 7.85V12.65C2.25 13.9101 2.25 14.5402 2.49524 15.0215C2.71095 15.4448 3.05516 15.789 3.47852 16.0048C3.95982 16.25 4.58988 16.25 5.85 16.25H10.65C11.9101 16.25 12.5402 16.25 13.0215 16.0048C13.4448 15.789 13.789 15.4448 14.0048 15.0215C14.25 14.5402 14.25 13.9101 14.25 12.65V11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LinkExternalIcon;
